import React from 'react';
import './Cart.css'
import '../Players/Player';



const Cart = (props) => {
    const cart =props.cart;
     
    
  
    
    
   
     
    let total = 0;
    for (let i = 0; i <cart.length; i++) {
        let player = cart[i];
        
       total= total + player.salary;
       
     
 
}


 


    
    return (
        
        
        <div>
            
           
            
            
 <h5>Player Selection Summary</h5>
            <h6>Number of selected player: {cart.length}</h6>
            <h6>Total Expense: {total} USD</h6>
            <h5>Selected Players Name:</h5>
            
            <ul>
            {cart.map(player => <li><h6 className="cart-list"> {player.name}</h6></li>)}
            
            </ul>
            <h5>Selected Players Salary:</h5>
            <ul>
            {cart.map(player => <li><h6 className="cart-list">  {player.salary} USD </h6></li>)}
            </ul>
            
          
          
            
             
         </div>
    );
};

export default Cart;